import Lrc from './Lrc'

/**
 * 酷我音译逐行歌词
 */
export default class LrcRoma extends Lrc {
  constructor() {
    super('lyricLrcRoma')
    this.nameExt = '_roma'
  }
}
